module.exports = __webpack_public_path__ + "static/media/icon-04.74afecfb.png";